import React, { useEffect, useState } from "react";
import StatusBadge from "../StatusBadge/StatusBadge";
import DetailsPanel from "./DetailsPanel";
import classNames from "classnames";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import styles from "./DetailsPanel.module.scss";
import ImagePreviewLightbox from "../ImagePreviewLightbox";
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const UsersDetailsPanel = ({ onClose, item, fetchUsers }) => {
  console.log("team", item);
  const [imgSrc, setImgSrc] = useState(item?.profilePic);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (item) {
      setUserData(item);
    }
  }, [item])

  const getPhone = (userInfo) => {
    let phoneNo = userInfo?.phoneNo || "";
    const countryCode = userInfo?.countryCode || "";
    console.log("asdasd", phoneNo)
    if (phoneNo.startsWith("0")) {
      phoneNo = phoneNo.slice(1);
    }

    const phoneString = `+${countryCode}${phoneNo}`;
    const parsed = parsePhoneNumberFromString(phoneString);

    if (!parsed) return "";

    // 📞 Example output: +91 91234 56789 or +1 (201) 555-0123
    return `+${parsed.countryCallingCode} ${parsed.formatNational().startsWith("0") ? parsed.formatNational().slice(1) : parsed.formatNational()}`;
  };


  useEffect(() => {
    setImgSrc(item?.profilePic);
  }, []);
  const roles = {
    3: { label: "Expert", color: "Success" },
    5: { label: "Staff", color: "Pending" },
  };

  return (
    <DetailsPanel isOpen={!!item} >
      <div
        className={classNames(
          styles["detail-panel-head"],
          "d-flex align-items-center justify-content-between gap-3"
        )}
      >
        <h2 className="h5 fw-semibold mb-0">Details</h2>
        <button type="button" className="btn-reset" onClick={onClose}>
          <Image src="/images/btn-close-square.svg" />
        </button>
      </div>
      <div className={styles["detail-panel-body"]}>
        <div className="d-flex align-items-center gap-2 mb-3">
          {item?.profilePic ? (
            <ImagePreviewLightbox className="user-avtar user-avtar-48" src={item?.profilePic}>
              <Image
                src={item?.profilePic}
                className="object-fit-cover rounded-circle"
                width="48"
                height="48"
                alt={item?.firstName}
              />
            </ImagePreviewLightbox>
          ) : (
            <Image
              width={48}
              height={48}
              alt="User Avatar"
              className="object-fit-cover rounded-circle"
              src={`https://ui-avatars.com/api/?name=${item?.firstName}+${item?.lastName}&background=007bff&color=fff&size=100`}
            />
          )}
          <h3 className="h6 mb-0 fw-semibold d-flex align-items-center gap-2">
            {item?.firstName} {item?.lastName}{" "}
            <StatusBadge
              status={roles[item?.roleId]?.color}
              label={roles[item?.roleId]?.label}
            />
          </h3>
        </div>

        <div className="border-top pt-3 mt-3">
          <h4 className="text-blue fs-7 fw-medium mb-3">Personal Details</h4>

          <ul className="list-unstyled">
            <li className="fs-6 mb-3">
              <span className="fs-7 text-gray-500 d-block">Email Address</span>
              {item?.email}
            </li>

            {item?.phoneNo && (
              <li className="fs-6 mb-3">
                <span className="fs-7 text-gray-500 d-block">Phone</span>
                {getPhone(item)}
              </li>
            )}

            {item?.address && (
              <li className="fs-6 mb-3">
                <span className="fs-7 text-gray-500 d-block">Address</span>
                {item?.address}, {item?.city}, {item?.state?.name},{item?.country?.code} {item?.zipCode}
              </li>
            )}
          </ul>
        </div>

        {item?.roleId === 3 &&
          item?.expertiseAssign &&
          item?.expertiseAssign.length > 0 && (
            <div className="border-top pt-3 mt-3">
              <h4 className="text-blue fs-7 fw-medium mb-3">Expertise</h4>
              <ul className="chat-contact-list list-unstyled">
                {item?.expertiseAssign?.map((elem) => {
                  return (
                    <li className="d-flex align-items-center mb-3">
                      <ImagePreviewLightbox
                        className="product-icon"
                        src={
                          elem?.expertise?.images && elem?.expertise?.images[0]
                            ? elem?.expertise?.images[0]
                            : "/images/product-icon.png"
                        }
                      >
                        <Image
                          className="object-fit-cover rounded-pill"
                          src={
                            elem?.expertise?.images && elem?.expertise?.images[0]
                              ? elem?.expertise?.images[0]
                              : "/images/product-icon.png"
                          }
                          width={56}
                          height={56}
                          alt="Product Icon"
                        />
                      </ImagePreviewLightbox>
                      <div className="ms-3">
                        <h3 className="h6 mb-1 fw-semibold">
                          {elem?.expertise?.name}
                        </h3>
                        {/* <h4 className="fs-7 text-gray-500 mb-0">{elem?.expertise?.name}</h4> */}
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
      </div>
    </DetailsPanel>
  );
};

export default UsersDetailsPanel;
